import { helpers } from 'vuelidate/lib/validators'
import zxcvbn from 'zxcvbn'

export default password => {
    const penalizedWords = [
        'hot',
        'springs',
        'water',
        'swim',
    ]
    
    return !helpers.req(password) || zxcvbn(password, penalizedWords).score >= 2
};